import { gql } from 'graphql-request'

export const QueryBlock2ColumnsIntegrationList = gql`
  fragment FragmentBlock2ColumnsIntegrationList on Block2ColumnsIntegrationListModelRecord {
    __typename
    id
    title
    description {
      value
    }
    action {
      ...FragmentNavigationItem
    }
    column1Integrations {
      id
      title
      label
      logo {
        url
      }
      logoLight {
        url
      }
      slug
      categories {
        title
      }
      markets {
        countryIsoCode
      }
    }
  }
`

export const Block2ColumnsIntegrationList = {
  __typename: 'Block2ColumnsIntegrationList',
  fragmentName: 'FragmentBlock2ColumnsIntegrationList',
  fragmentQuery: QueryBlock2ColumnsIntegrationList,
  fragments: ['FragmentNavigationItem']
}
